<template>
  <div>
    <van-collapse v-model="activeNames" class="mytab1">
      <van-collapse-item
        :name="index"
        v-for="(item, index) in list"
        :key="index"
        :value="item.value + '分'"
      >
        <template #title>
          <div class="pointImgcomment">
            <img :src="require(`@/assets/image/anxin/${item.name}.png`)" />
            <span>
              {{ item.name }}
            </span>
            <b
              :style="{
                color:
                  item.status == '较差'
                    ? '#D45353'
                    : item.status == '中等'
                    ? '#F1BE33'
                    : item.status == '良好'
                    ? '#9EF133'
                    : '#28D200',
              }"
            >
              ({{ item.status }})
            </b>
          </div>
        </template>
        <div>
          <markbox :item="item" v-if="laiyuan !== 'renti'"></markbox>
          <div class="intes-cjfx">
            <div>
              <h3>词条解释</h3>
              <p v-html="item.definition"></p>
            </div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import markbox from "./markBox.vue"
import { Dialog } from 'vant';
export default {
  props: ['list', 'laiyuan'],
  components: {
    markbox
  },
  data () {
    return {
      activeNames: [],

    }
  },
  watch: {
    list: {
      handler (newValue, oldValue) {

        this.list = newValue;
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    handClickJd () {

      Dialog.alert({
        title: '专家建议',
        messageAlign: "left",
        theme: 'round-button',
        closeOnClickOverlay: true,
        confirmButtonColor: '#A7DDFF',
        confirmButtonText: '关闭',
        width: 320,
        className: 'peaceH5dialogText',
        message: '对于得分偏低（特别是＜60分）的情况，给予对应的专家建议、居家调理建议，该建议仅作为个人健康管理参考使用，不作为医疗处方，用户可结合自身情况进行合理选择。\n\n祝您健康！',
      }).then(() => {
        // on close
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.mytab {
  box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.1);
  border-radius: 10px;
  overflow: hidden;
}
.pointImgcomment {
  img {
    width: 65px;
    height: 65px;
    vertical-align: middle;
    margin-right: 20px;
  }
  span {
    font-size: 26px;
    vertical-align: middle;
    display: inline-block;
  }
  b {
    font-weight: 400;
    font-size: 26px;
    margin-left: 10px;
    i {
      font-style: normal;
    }
  }
}
.intes-cjfx {
  padding: 30px;
  background: #f4faff;
  font-size: 26px;
  div {
    margin-bottom: 30px;
  }
  div:last-child {
    margin-bottom: 0;
  }
  h3 {
    color: #3195e6;
    margin: 0;
    img {
      width: 27px;
      height: 27px;
      margin-left: 10px;
    }
  }
  p {
    color: #333;
    margin: 0;
  }
}
</style>